module.exports = __webpack_public_path__ + "media/images/home-m-2-2ab86d5b0c1e112a826a2e0d149e2d23.jpg";